import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3bfed5f8")

_pushScopeId("data-v-3bfed5f8")
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_activate_ai",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Activate Business AI", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_9 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_modal_activate_ai_stepper",
  ref: "createAppRef"
}
const _hoisted_10 = { class: "d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px" }
const _hoisted_11 = { class: "stepper-nav ps-lg-10" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-item current\" data-kt-stepper-element=\"nav\" data-v-3bfed5f8><div class=\"stepper-line w-40px\" data-v-3bfed5f8></div><div class=\"stepper-icon w-40px h-40px\" data-v-3bfed5f8><i class=\"stepper-check fas fa-check\" data-v-3bfed5f8></i><span class=\"stepper-number\" data-v-3bfed5f8>1</span></div><div class=\"stepper-label\" data-v-3bfed5f8><h3 class=\"stepper-title\" data-v-3bfed5f8> Details </h3><div class=\"stepper-desc\" data-v-3bfed5f8> Name of Business </div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-3bfed5f8><div class=\"stepper-line w-40px\" data-v-3bfed5f8></div><div class=\"stepper-icon w-40px h-40px\" data-v-3bfed5f8><i class=\"stepper-check fas fa-check\" data-v-3bfed5f8></i><span class=\"stepper-number\" data-v-3bfed5f8>2</span></div><div class=\"stepper-label\" data-v-3bfed5f8><h3 class=\"stepper-title\" data-v-3bfed5f8> Owner&#39;s Info </h3><div class=\"stepper-desc\" data-v-3bfed5f8> Define owner information </div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-3bfed5f8><div class=\"stepper-line w-40px\" data-v-3bfed5f8></div><div class=\"stepper-icon w-40px h-40px\" data-v-3bfed5f8><i class=\"stepper-check fas fa-check\" data-v-3bfed5f8></i><span class=\"stepper-number\" data-v-3bfed5f8>3</span></div><div class=\"stepper-label\" data-v-3bfed5f8><h3 class=\"stepper-title\" data-v-3bfed5f8> Address </h3><div class=\"stepper-desc\" data-v-3bfed5f8> Business Address </div></div></div>", 3)
const _hoisted_15 = {
  key: 0,
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-line w-40px\" data-v-3bfed5f8></div><div class=\"stepper-icon w-40px h-40px\" data-v-3bfed5f8><i class=\"stepper-check fas fa-check\" data-v-3bfed5f8></i><span class=\"stepper-number\" data-v-3bfed5f8>4</span></div><div class=\"stepper-label\" data-v-3bfed5f8><h3 class=\"stepper-title\" data-v-3bfed5f8> Network Info </h3><div class=\"stepper-desc\" data-v-3bfed5f8> Provide network details </div></div>", 3)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-3bfed5f8><div class=\"stepper-line w-40px\" data-v-3bfed5f8></div><div class=\"stepper-icon w-40px h-40px\" data-v-3bfed5f8><i class=\"stepper-check fas fa-check\" data-v-3bfed5f8></i><span class=\"stepper-number\" data-v-3bfed5f8><i class=\"fas fa-flag-checkered\" data-v-3bfed5f8></i></span></div><div class=\"stepper-label\" data-v-3bfed5f8><h3 class=\"stepper-title\" data-v-3bfed5f8> Review </h3><div class=\"stepper-desc\" data-v-3bfed5f8> Review and Submit </div></div></div>", 1)
const _hoisted_20 = { class: "flex-row-fluid py-lg-5 px-lg-15" }
const _hoisted_21 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_22 = { class: "w-100" }
const _hoisted_23 = { class: "fv-row mb-10" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Business Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify business name"
  })
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "text-center px-4 py-15" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "media/ai247.jpg",
    alt: "",
    class: "mw-200 mh-250px"
  })
], -1)
const _hoisted_26 = { "data-kt-stepper-element": "content" }
const _hoisted_27 = { class: "w-100" }
const _hoisted_28 = { class: "fv-row" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-4" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Owner's details"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify your apps framework"
  })
], -1)
const _hoisted_30 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Owner's First Name"
  })
], -1)
const _hoisted_32 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Last Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Owner's Last Name"
  })
], -1)
const _hoisted_34 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Email Address"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Owner's Email Address"
  })
], -1)
const _hoisted_36 = { "data-kt-stepper-element": "content" }
const _hoisted_37 = { class: "w-100" }
const _hoisted_38 = { class: "fv-row" }
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Contact Phone"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Phone number must be active"
  })
], -1)
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Address Line 1", -1)
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Country"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Country of origination"
  })
], -1)
const _hoisted_51 = { class: "col-lg-8 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createVNode("option", {
  value: '',
  label: ''
}, null, -1)
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "State/Province"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "State/Province"
  })
], -1)
const _hoisted_57 = { class: "col-lg-8 fv-row" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "City")
], -1)
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "row mb-6" }
const _hoisted_66 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Postal Code"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Postal Code"
  })
], -1)
const _hoisted_67 = { class: "col-lg-8 fv-row" }
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Timezone"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Timezone"
  })
], -1)
const _hoisted_72 = { class: "col-lg-8 fv-row" }
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = {
  key: 0,
  "data-kt-stepper-element": "content"
}
const _hoisted_76 = { class: "w-100" }
const _hoisted_77 = {
  key: 0,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Username"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a username"
  })
], -1)
const _hoisted_79 = {
  key: 1,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Password"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a password"
  })
], -1)
const _hoisted_81 = {
  key: 2,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Confirm Password"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Confirm password"
  })
], -1)
const _hoisted_83 = {
  key: 3,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify your first name"
  })
], -1)
const _hoisted_85 = {
  key: 4,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_86 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Middle Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify your middile name"
  })
], -1)
const _hoisted_87 = {
  key: 5,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Last Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify your last name"
  })
], -1)
const _hoisted_89 = {
  key: 6,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_90 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Birth Date"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify your birth date"
  })
], -1)
const _hoisted_91 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_92 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Sponsor ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a sponsor ID"
  })
], -1)
const _hoisted_93 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_94 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Upline ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a upline ID"
  })
], -1)
const _hoisted_95 = { class: "row mb-10" }
const _hoisted_96 = { class: "col-md-8 fv-row" }
const _hoisted_97 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Position", -1)
const _hoisted_98 = { class: "row fv-row" }
const _hoisted_99 = { class: "col-6" }
const _hoisted_100 = /*#__PURE__*/_createVNode("option", {
  value: '',
  label: ''
}, null, -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("option", {
  value: 'L',
  label: 'Left'
}, null, -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("option", {
  value: 'R',
  label: 'Right'
}, null, -1)
const _hoisted_103 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_104 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "User ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a user ID"
  })
], -1)
const _hoisted_105 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_106 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "PIN"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a PIN"
  })
], -1)
const _hoisted_107 = { "data-kt-stepper-element": "content" }
const _hoisted_108 = { class: "w-100 text-center" }
const _hoisted_109 = /*#__PURE__*/_createVNode("h1", { class: "fw-bolder text-dark mb-3" }, "Confirm", -1)
const _hoisted_110 = /*#__PURE__*/_createVNode("div", { class: "text-muted fw-bold fs-3" }, " Please check all details before submitting. ", -1)
const _hoisted_111 = { class: "card mb-10" }
const _hoisted_112 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title" }, "Review Your Details")
], -1)
const _hoisted_113 = { class: "card-body" }
const _hoisted_114 = { class: "list-group list-group-flush text-start" }
const _hoisted_115 = { class: "list-group-item" }
const _hoisted_116 = /*#__PURE__*/_createVNode("strong", null, "Business Name:", -1)
const _hoisted_117 = { class: "list-group-item" }
const _hoisted_118 = /*#__PURE__*/_createVNode("strong", null, "Owner's First Name:", -1)
const _hoisted_119 = { class: "list-group-item" }
const _hoisted_120 = /*#__PURE__*/_createVNode("strong", null, "Owner's Last Name:", -1)
const _hoisted_121 = { class: "list-group-item" }
const _hoisted_122 = /*#__PURE__*/_createVNode("strong", null, "Owner's Email:", -1)
const _hoisted_123 = { class: "list-group-item" }
const _hoisted_124 = /*#__PURE__*/_createVNode("strong", null, "Contact Phone:", -1)
const _hoisted_125 = { class: "list-group-item" }
const _hoisted_126 = /*#__PURE__*/_createVNode("strong", null, "Address Line 1:", -1)
const _hoisted_127 = { class: "list-group-item" }
const _hoisted_128 = /*#__PURE__*/_createVNode("strong", null, "Country:", -1)
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { class: "list-group-item" }
const _hoisted_132 = /*#__PURE__*/_createVNode("strong", null, "State:", -1)
const _hoisted_133 = { class: "list-group-item" }
const _hoisted_134 = /*#__PURE__*/_createVNode("strong", null, "City:", -1)
const _hoisted_135 = { key: 0 }
const _hoisted_136 = { key: 1 }
const _hoisted_137 = { class: "list-group-item" }
const _hoisted_138 = /*#__PURE__*/_createVNode("strong", null, "Postal Code:", -1)
const _hoisted_139 = { class: "list-group-item" }
const _hoisted_140 = /*#__PURE__*/_createVNode("strong", null, "Timezone:", -1)
const _hoisted_141 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_142 = /*#__PURE__*/_createVNode("strong", null, "Username:", -1)
const _hoisted_143 = {
  key: 1,
  class: "list-group-item"
}
const _hoisted_144 = /*#__PURE__*/_createVNode("strong", null, "First Name:", -1)
const _hoisted_145 = {
  key: 2,
  class: "list-group-item"
}
const _hoisted_146 = /*#__PURE__*/_createVNode("strong", null, "Middle Name:", -1)
const _hoisted_147 = {
  key: 3,
  class: "list-group-item"
}
const _hoisted_148 = /*#__PURE__*/_createVNode("strong", null, "Last Name:", -1)
const _hoisted_149 = {
  key: 4,
  class: "list-group-item"
}
const _hoisted_150 = /*#__PURE__*/_createVNode("strong", null, "Birth Date:", -1)
const _hoisted_151 = {
  key: 5,
  class: "list-group-item"
}
const _hoisted_152 = /*#__PURE__*/_createVNode("strong", null, "Sponsor ID:", -1)
const _hoisted_153 = {
  key: 6,
  class: "list-group-item"
}
const _hoisted_154 = /*#__PURE__*/_createVNode("strong", null, "Upline ID:", -1)
const _hoisted_155 = {
  key: 7,
  class: "list-group-item"
}
const _hoisted_156 = /*#__PURE__*/_createVNode("strong", null, "Position:", -1)
const _hoisted_157 = {
  key: 8,
  class: "list-group-item"
}
const _hoisted_158 = /*#__PURE__*/_createVNode("strong", null, "User ID:", -1)
const _hoisted_159 = {
  key: 9,
  class: "list-group-item"
}
const _hoisted_160 = /*#__PURE__*/_createVNode("strong", null, "PIN:", -1)
const _hoisted_161 = { class: "d-flex flex-stack pt-10" }
const _hoisted_162 = { class: "me-2" }
const _hoisted_163 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_164 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_165 = { class: "indicator-label" }
const _hoisted_166 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_167 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_168 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_169 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_170 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_171 = { class: "svg-icon svg-icon-3 ms-1 me-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                (_ctx.formData.encodingType !== 'activation')
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_19
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("form", {
                class: "form",
                novalidate: "novalidate",
                id: "kt_modal_activate_ai_form",
                onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
              }, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "businessName",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "businessName"
                      })
                    ]),
                    _hoisted_25
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "prospectFirstName"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "prospectFirstName"
                        })
                      ]),
                      _createVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "prospectLastName"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "prospectLastName"
                        })
                      ]),
                      _createVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "prospectEmail"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "prospectEmail"
                        })
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "framework"
                      })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode("div", _hoisted_41, [
                          _createVNode(_component_Field, {
                            type: "tel",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: "Phone number",
                            name: "prospectContactPhone"
                          }),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _createVNode(_component_ErrorMessage, { name: "phone" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode("div", _hoisted_46, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: "Street address, name of building, suite, unit, floor, etc",
                            name: "companyAddress"
                          }),
                          _createVNode("div", _hoisted_47, [
                            _createVNode("div", _hoisted_48, [
                              _createVNode(_component_ErrorMessage, { name: "website" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createVNode("div", _hoisted_51, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "country",
                            class: "form-select form-select-solid form-select-lg fw-bold",
                            modelValue: _ctx.formData.country,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.country = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCities(_ctx.formData.country)))
                          }, {
                            default: _withId(() => [
                              _hoisted_52,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: country.iso_code_2,
                                  value: country.country_id,
                                  label: country.name
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_53, [
                            _createVNode("div", _hoisted_54, [
                              _createVNode(_component_ErrorMessage, { name: "country" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createVNode("div", _hoisted_57, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "countryState",
                            class: "form-select form-select-solid form-select-lg fw-bold"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.zone_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_58, [
                            _createVNode("div", _hoisted_59, [
                              _createVNode(_component_ErrorMessage, { name: "countryState" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createVNode("div", _hoisted_62, [
                          _createVNode(_component_Field, {
                            type: "tel",
                            name: "city",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: "City"
                          }),
                          _createVNode("div", _hoisted_63, [
                            _createVNode("div", _hoisted_64, [
                              _createVNode(_component_ErrorMessage, { name: "phone" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createVNode("div", _hoisted_67, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: "Postal Code",
                            name: "postalCode"
                          }),
                          _createVNode("div", _hoisted_68, [
                            _createVNode("div", _hoisted_69, [
                              _createVNode(_component_ErrorMessage, { name: "postalCode" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _createVNode("div", _hoisted_72, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "timezone",
                            class: "form-select form-select-solid form-select-lg fw-bold"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeZones, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.zone,
                                  value: i.zone
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_73, [
                            _createVNode("div", _hoisted_74, [
                              _createVNode(_component_ErrorMessage, { name: "timezone" })
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "dbType"
                      })
                    ])
                  ])
                ]),
                (_ctx.formData.encodingType !== 'activation')
                  ? (_openBlock(), _createBlock("div", _hoisted_75, [
                      _createVNode("div", _hoisted_76, [
                        (_ctx.formData.encodingType === 'regnew')
                          ? (_openBlock(), _createBlock("div", _hoisted_77, [
                              _hoisted_78,
                              _createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid",
                                placeholder: "",
                                name: "username"
                              }),
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "username"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.encodingType === 'regnew')
                          ? (_openBlock(), _createBlock("div", _hoisted_79, [
                              _hoisted_80,
                              _createVNode(_component_Field, {
                                type: "password",
                                class: "form-control form-control-solid",
                                placeholder: "",
                                name: "password"
                              }),
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "password"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.encodingType === 'regnew')
                          ? (_openBlock(), _createBlock("div", _hoisted_81, [
                              _hoisted_82,
                              _createVNode(_component_Field, {
                                type: "password",
                                class: "form-control form-control-solid",
                                placeholder: "",
                                name: "cpassword"
                              }),
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "cpassword"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.encodingType === 'regnew')
                          ? (_openBlock(), _createBlock("div", _hoisted_83, [
                              _hoisted_84,
                              _createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid",
                                placeholder: "",
                                name: "firstname"
                              }),
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "firstname"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.encodingType === 'regnew')
                          ? (_openBlock(), _createBlock("div", _hoisted_85, [
                              _hoisted_86,
                              _createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid",
                                placeholder: "",
                                name: "mi"
                              }),
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "mi"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.encodingType === 'regnew')
                          ? (_openBlock(), _createBlock("div", _hoisted_87, [
                              _hoisted_88,
                              _createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid",
                                placeholder: "",
                                name: "lastname"
                              }),
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "lastname"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.encodingType === 'regnew')
                          ? (_openBlock(), _createBlock("div", _hoisted_89, [
                              _hoisted_90,
                              _createVNode(_component_Field, {
                                type: "date",
                                class: "form-control form-control-solid",
                                placeholder: "",
                                name: "bd"
                              }),
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "bd"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_91, [
                          _hoisted_92,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "sponsorid"
                          }),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "sponsorid"
                          })
                        ]),
                        _createVNode("div", _hoisted_93, [
                          _hoisted_94,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "uplineid"
                          }),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "uplineid"
                          })
                        ]),
                        _createVNode("div", _hoisted_95, [
                          _createVNode("div", _hoisted_96, [
                            _hoisted_97,
                            _createVNode("div", _hoisted_98, [
                              _createVNode("div", _hoisted_99, [
                                _createVNode(_component_Field, {
                                  name: "position",
                                  class: "form-select form-select-solid select2-hidden-accessible",
                                  placeholder: "Position",
                                  as: "select"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_100,
                                    _hoisted_101,
                                    _hoisted_102
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ErrorMessage, {
                                  class: "fv-plugins-message-container invalid-feedback",
                                  name: "position"
                                })
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_103, [
                          _hoisted_104,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "userid"
                          }),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "userid"
                          })
                        ]),
                        _createVNode("div", _hoisted_105, [
                          _hoisted_106,
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "securitypin"
                          }),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "securitypin"
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_107, [
                  _createVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _hoisted_110,
                    _createVNode("div", _hoisted_111, [
                      _hoisted_112,
                      _createVNode("div", _hoisted_113, [
                        _createVNode("div", null, [
                          _createVNode("ul", _hoisted_114, [
                            _createVNode("li", _hoisted_115, [
                              _hoisted_116,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.businessName), 1)
                            ]),
                            _createVNode("li", _hoisted_117, [
                              _hoisted_118,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.prospectFirstName), 1)
                            ]),
                            _createVNode("li", _hoisted_119, [
                              _hoisted_120,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.prospectLastName), 1)
                            ]),
                            _createVNode("li", _hoisted_121, [
                              _hoisted_122,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.prospectEmail), 1)
                            ]),
                            _createVNode("li", _hoisted_123, [
                              _hoisted_124,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.prospectContactPhone), 1)
                            ]),
                            _createVNode("li", _hoisted_125, [
                              _hoisted_126,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.companyAddress), 1)
                            ]),
                            _createVNode("li", _hoisted_127, [
                              _hoisted_128,
                              (_ctx.selectedCountry)
                                ? (_openBlock(), _createBlock("span", _hoisted_129, _toDisplayString(_ctx.selectedCountry.name), 1))
                                : (_openBlock(), _createBlock("span", _hoisted_130, _toDisplayString(_ctx.formData.country), 1))
                            ]),
                            _createVNode("li", _hoisted_131, [
                              _hoisted_132,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.countryState), 1)
                            ]),
                            _createVNode("li", _hoisted_133, [
                              _hoisted_134,
                              (_ctx.selectedCity)
                                ? (_openBlock(), _createBlock("span", _hoisted_135, _toDisplayString(_ctx.selectedCity.name), 1))
                                : (_openBlock(), _createBlock("span", _hoisted_136, _toDisplayString(_ctx.formData.city), 1))
                            ]),
                            _createVNode("li", _hoisted_137, [
                              _hoisted_138,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.postalCode), 1)
                            ]),
                            _createVNode("li", _hoisted_139, [
                              _hoisted_140,
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.timezone), 1)
                            ]),
                            (_ctx.formData.encodingType === 'regnew')
                              ? (_openBlock(), _createBlock("li", _hoisted_141, [
                                  _hoisted_142,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.username), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.encodingType === 'regnew')
                              ? (_openBlock(), _createBlock("li", _hoisted_143, [
                                  _hoisted_144,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.firstname), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.encodingType === 'regnew')
                              ? (_openBlock(), _createBlock("li", _hoisted_145, [
                                  _hoisted_146,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.mi), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.encodingType === 'regnew')
                              ? (_openBlock(), _createBlock("li", _hoisted_147, [
                                  _hoisted_148,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.lastname), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.encodingType === 'regnew')
                              ? (_openBlock(), _createBlock("li", _hoisted_149, [
                                  _hoisted_150,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.bd), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (['regnew', 'regmultiple'].includes(_ctx.formData.encodingType))
                              ? (_openBlock(), _createBlock("li", _hoisted_151, [
                                  _hoisted_152,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.sponsorid), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (['regnew', 'regmultiple'].includes(_ctx.formData.encodingType))
                              ? (_openBlock(), _createBlock("li", _hoisted_153, [
                                  _hoisted_154,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.uplineid), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (['regnew', 'regmultiple'].includes(_ctx.formData.encodingType))
                              ? (_openBlock(), _createBlock("li", _hoisted_155, [
                                  _hoisted_156,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.position), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (['regnew', 'regmultiple'].includes(_ctx.formData.encodingType))
                              ? (_openBlock(), _createBlock("li", _hoisted_157, [
                                  _hoisted_158,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.userid), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (['regnew', 'regmultiple'].includes(_ctx.formData.encodingType))
                              ? (_openBlock(), _createBlock("li", _hoisted_159, [
                                  _hoisted_160,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formData.securitypin), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_161, [
                  _createVNode("div", _hoisted_162, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-light-primary me-3",
                      "data-kt-stepper-action": "previous",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.previousStep())),
                      disabled: _ctx.isSubmitting
                    }, [
                      _createVNode("span", _hoisted_163, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                      ]),
                      _hoisted_164
                    ], 8, ["disabled"])
                  ]),
                  _createVNode("div", null, [
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-lg btn-primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit())),
                          disabled: _ctx.isSubmitting
                        }, [
                          _createVNode("span", _hoisted_165, [
                            _hoisted_166,
                            _createVNode("span", _hoisted_167, [
                              _createVNode(_component_inline_svg, { src: "icons/duotone/Navigation/Right-2.svg" })
                            ])
                          ]),
                          _hoisted_168
                        ], 8, ["disabled"]))
                      : (_openBlock(), _createBlock("button", _hoisted_169, [
                          _hoisted_170,
                          _createVNode("span", _hoisted_171, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                          ])
                        ]))
                  ])
                ])
              ], 32)
            ])
          ], 512)
        ])
      ])
    ])
  ]))
})